/** @format */

import { useContext } from "react";
import { BrandContext } from "../contexts/brand/BrandContext";

export const useBrand = () => {
	const context = useContext(BrandContext);
	if (!context) {
		throw new Error("useBrand must be used within the BrandProvider component");
	}
	return context;
};
